import { Component, OnInit, OnDestroy, EventEmitter, Output, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  CompanyWorkflowGendocProcessContainerModel, CompanyWorkflowGendocProcessService
} from 'blg-akaun-ts-lib';
import { AppConfig } from '../../visa';
import { ReplaySubject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { SubSink } from 'subsink2';

@Component({
  selector: 'company-workflow-dropdown',
  templateUrl: './company-workflow-dropdown.component.html',
  styleUrls: ['./company-workflow-dropdown.component.css']
})
export class CompanyWorkflowDropdownComponent implements OnInit, OnDestroy {

  @Input() processGuid: FormControl;
  @Input() processName: string = "Process"; // Default value "Process" 
  @Output() processChange = new EventEmitter<FormControl>();

  private subs = new SubSink();
  appletGuid = sessionStorage.getItem('appletGuid');

  private apiVisa = AppConfig.apiVisa;
  filterControl = new FormControl();
  filteredOptions$: ReplaySubject<CompanyWorkflowGendocProcessContainerModel[]> = new ReplaySubject<CompanyWorkflowGendocProcessContainerModel[]>(1);
  companyList: CompanyWorkflowGendocProcessContainerModel[];

  constructor(
     private companyWorkflowGendocProcessService: CompanyWorkflowGendocProcessService 
     ) {}

  ngOnInit() {
    this.subs.sink = this.companyWorkflowGendocProcessService.get(this.apiVisa).subscribe(
      {next: resolve => {
        const filteredData = resolve.data.filter(item => item.bl_fi_comp_workflow_gendoc_process_template_hdr.applet_guid === this.appletGuid.toString());
        console.log("DEBUG::filteredData", filteredData)
        this.companyList = filteredData;
        this.filteredOptions$.next(this.companyList);
      }});
    this.subs.sink = this.filterControl.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe({next: resolve => this.filterApplet(resolve)});
  }

  filterApplet(search: string) {
    if (!search) {
      this.filteredOptions$.next(this.companyList);
    } else {
      search = search.toLocaleLowerCase();
      const filter = this.companyList.filter(c => c.bl_fi_comp_workflow_gendoc_process_template_hdr.process_hdr_code.toLocaleLowerCase().includes(search));
      this.filteredOptions$.next(filter);
    }

  }

  onProcessChange() {
    this.processChange.emit(this.processGuid); // Emit the selected workflow to the parent
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
